import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Form, InputGroup } from "react-bootstrap";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import { BASE_URL } from "../../Const/Url";
import { showToast } from "../../../utils/ToastHelper";
import SelectOpenWithPagginationDynamic from "../../Const/SelectOpenWithPagginationDynamic";
import { handleSelectAll } from "../../Const/Status";
import { logout_func2 } from "../../Const/logoutCommon";
import Loader from "../../CustomCommons/Loader";
import * as path from "../../Routes/RoutePaths";

const EditTopBanner = () => {
  const history = useHistory();
  const { slug } = useParams();
  const [title, setTitle] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [order, setOrder] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [productList, setProductsList] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [, setOnlogoutHide] = useState(0);

  const handleProductChange = (newValue) => {
    setSelectedProducts(newValue);
  };

  const handleProductInput = (inputValue) => {
    setInputQuery(inputValue);
  };

  const loadBannerDetails = useCallback(() => {
    setIsLoading(true);
    axios
      .get(`${BASE_URL}api/v1/frontend/admin/v2/top-text-banners/${slug}/`)
      .then((res) => {
        const payload = res?.data?.data || {};
        setTitle(payload?.title || "");
        setButtonText(payload?.button_text || "");
        setOrder(payload?.order ?? "");
        setIsActive(payload?.is_active ?? true);

        const preselected =
          payload?.products_details?.map((product) => ({
            label: product?.name,
            value: product?.id,
          })) || [];
        setSelectedProducts(preselected);
        setProductsList(preselected);
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401) {
          logout_func2(setOnlogoutHide, history);
          return;
        }
        const message =
          err?.response?.data?.errors?.non_field_errors?.[0] ||
          err?.response?.data?.message ||
          "Failed to load top banner details. Please try again.";
        showToast("error", message);
      })
      .finally(() => setIsLoading(false));
  }, [slug, history]);

  useEffect(() => {
    if (slug) {
      loadBannerDetails();
    }
  }, [slug, loadBannerDetails]);

  const handleSubmit = () => {
    if (!title.trim()) {
      showToast("error", "Title is required.");
      return;
    }
    if (!buttonText.trim()) {
      showToast("error", "Button text is required.");
      return;
    }
    if (!order && order !== 0) {
      showToast("error", "Order is required.");
      return;
    }
    if (!selectedProducts.length) {
      showToast("error", "Select at least one product.");
      return;
    }

    const payload = {
      products: selectedProducts.map((product) => product.value),
      title,
      url: "",
      button_text: buttonText,
      is_active: isActive,
      order: Number(order),
    };

    setIsSubmitting(true);
    axios
      .patch(
        `${BASE_URL}api/v1/frontend/admin/v2/top-text-banners/${slug}/`,
        payload
      )
      .then(() => {
        showToast("success", "Top banner updated successfully.");
        history.push(path.top_banner_list);
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401) {
          logout_func2(setOnlogoutHide, history);
          return;
        }
        const message =
          err?.response?.data?.message ||
          "Failed to update top banner. Please try again.";
        showToast("error", message);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleCancel = () => {
    history.push(path.top_banner_list);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Edit Top Text Banner
          </h3>
        </div>

        <div
          style={{
            padding: "20px 35px",
            borderBottom: "0.5px solid #E0E0E0",
            borderRight: "0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
          className="row"
        >
          <div className="col-12 col-md-6">
            <RequiredLabel text="Title" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Title"
                aria-describedby="title-input"
                style={{ backgroundColor: "#FAFAFA" }}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Order" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Order"
                aria-describedby="order-input"
                style={{ backgroundColor: "#FAFAFA" }}
                value={order}
                type="number"
                min={0}
                onChange={(e) => setOrder(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Button Text" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Button Text"
                aria-describedby="button-text-input"
                style={{ backgroundColor: "#FAFAFA" }}
                value={buttonText}
                onChange={(e) => setButtonText(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 mt-3">
            <RequiredLabel text="Products" />
            <div className="position-relative">
              <SelectOpenWithPagginationDynamic
                handleMultiInputChange={handleProductChange}
                inputProduct={handleProductInput}
                ProductsList={productList}
                defaultValue={selectedProducts}
                setProductsList={setProductsList}
                inputQuery={inputQuery}
                selectAll={() =>
                  handleSelectAll(productList, setSelectedProducts)
                }
                url1={`api/v1/inventory/inventory/product_list_for_offer/?is_website=true&is_admin=false&is_outlet=false&limit=20`}
                url2={`api/v1/inventory/inventory/product_list_for_offer/?query=${inputQuery}&is_website=true&is_admin=false&is_outlet=false&limit=20`}
              />
            </div>
          </div>

          <div className="col-12 mt-4">
            <h5>Status</h5>
            <p style={{ color: "#8E8E93" }}>( Toggle top banner visibility )</p>
            <div
              className="d-flex justify-content-between align-items-center py-3 px-3"
              style={{ backgroundColor: "#F2F2F7", borderRadius: "8px" }}
            >
              <div className="d-flex align-items-center">
                <span className="mx-2">{isActive ? "Active" : "Inactive"}</span>
              </div>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <button
              onClick={handleSubmit}
              className="save-btn me-2 mt-2"
              style={{ background: "#000", color: "white" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Updating..." : "Update"}
            </button>
            <button
              onClick={handleCancel}
              className="save-btn mt-2"
              style={{ border: ".4px solid #E0E0E0 !important" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTopBanner;
